import type { CapabilityConfig, ExtendedConstraints } from '../../../types';
import * as ControlSpec from '../control';

export const id = 'apps-dock-control';

export type Config = ControlSpec.Config & {
  type: typeof id;
};

export enum Events {
  CustomEvent = 'apps-dock-control:custom-event',
}
export enum Actions {}

export type CustomEventPayload = unknown;

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  eventPayloadTuple: [Events.CustomEvent, CustomEventPayload];
  eventHandlerTuple: [
    Events.CustomEvent,
    (payload: CustomEventPayload) => void,
  ];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!ControlSpec.isValidConfig(config)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
